import { render } from "./Section4Works.vue?vue&type=template&id=bfa91f74&scoped=true"
const script = {}

import "./Section4Works.vue?vue&type=style&index=0&id=bfa91f74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa91f74"]])

export default __exports__